/**
 * @generated SignedSource<<74251bad6516c63ee0f930d8acc923f9>>
 * @relayHash 639557290097baad0444efb493d46c33
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 639557290097baad0444efb493d46c33

import { ConcreteRequest } from 'relay-runtime';
export type AiResult = "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID" | "BREACHED_CONTENT_FILTER" | "FUNCTION_CALL" | "INVALID_QUESTIONNAIRE_DATA" | "JSON_ERROR" | "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED" | "MISSING_APPOINTMENT_DATA" | "MISSING_CALL_TRANSCRIPT" | "MISSING_CHAT_TRANSCRIPT" | "MISSING_CLINIBEE_GUIDELINES" | "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE" | "MISSING_QUESTIONNAIRE_DATA" | "MISSING_USER_INPUT" | "MISSING_USER_PROMPT" | "NOT_FOUND_OPEN_AI_PROMPT" | "PROCESS_TIMEOUT" | "SUCCESS" | "TOOL_CALLS" | "UNKNOWN_ERROR" | "UNRESOLVED_PLACEHOLDER" | "UNSUPPORTED_PLACEHOLDER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type QuestionnaireFlavour = "ANAMNESIS" | "CHAT";
export type SummarizeQuestionnaireInput = {
  aiRequestMetadata: AiRequestMetadataInput;
  flavour: QuestionnaireFlavour;
};
export type AiRequestMetadataInput = {
  age: number;
  aiFeatureId: string;
  appointmentId: string;
  gender: Gender;
  progressNoteId?: string | null;
  progressNotes?: ReadonlyArray<ProgressNoteAnamnesisInput> | null;
  specialtyOfPointOfCareForCurrentProgressNote?: string | null;
  targetAgentLanguage?: Language | null;
  userInput?: string | null;
};
export type ProgressNoteAnamnesisInput = {
  anamnesis: string;
  updatedAt: string;
};
export type deQuestionnaireSummarizerQuery$variables = {
  input: SummarizeQuestionnaireInput;
};
export type deQuestionnaireSummarizerQuery$data = {
  readonly summarizeQuestionnaire: {
    readonly aiAnonymizationRequestDurationMs: number;
    readonly aiRequestDurationMs: number;
    readonly fileHash: string;
    readonly result: AiResult;
    readonly text: string;
  };
};
export type deQuestionnaireSummarizerQuery = {
  response: deQuestionnaireSummarizerQuery$data;
  variables: deQuestionnaireSummarizerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "summarizeQuestionnaire",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TextResult",
    "kind": "LinkedField",
    "name": "de_summarizeQuestionnaire",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileHash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiRequestDurationMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiAnonymizationRequestDurationMs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deQuestionnaireSummarizerQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deQuestionnaireSummarizerQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "639557290097baad0444efb493d46c33",
    "metadata": {},
    "name": "deQuestionnaireSummarizerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0d49156e67c8ed3cd3c479c7bb841b1a";

export default node;
